import {
  IAcademiesStore,
} from '../../mobx-store/storeInterfaces/academiesInterface';
import {
  IBannerAdsStore,
} from '../../mobx-store/storeInterfaces/bannerAdsInterface';
import {
  IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { IEventStore } from '../../mobx-store/storeInterfaces/eventsInterface';
import { IAuthStore } from '../../mobx-store/storeInterfaces/authInterface';
import { INotification } from 'mobx-store/storeInterfaces/notificationInterface';
import { WheelFortuneStore } from 'mobx-store/stores/wheelFortuneStore';

export interface Props {
  eventStore?: IEventStore;
  bannerAdsStore?: IBannerAdsStore;
  academiesStore?: IAcademiesStore;
  branchStore?: IBranchStore;
  countryStore?: CountryStore;
  authStore?: IAuthStore;
  notificationStore: INotification;
  history: any;
  wheelFortuneStore: WheelFortuneStore;
};

export interface State {
  notificationTitleEn: string;
  notificationTitleAr: string;
  notificationBodyEn: string;
  notificationBodyAr: string;
  status: string;
  link: string;
  imageEn: any[];
  imageAr: any[];
  file: File[];
  fileData: string;
  type: string;
  internalNavigationType: string | null;
  internalNavigationItemId: number;
  navigationItems: any[];
  hideTitle: boolean;
  loadingCountry: boolean;
  open: boolean;
  notificationChannel: string;
  notificationScheduleType: NotificationScheduleType;
  triedToSubmit: boolean;
  nativeModuleMethodName: string;
  nativeModuleName: string;
}

export enum NotificationType {
  STATIC = "static",
  INTERNAL = "internal",
  EXTERNAL = "external",
  NATIVE = "native",
}

export enum NotificationScheduleType {
  BATCHES = 'Batches',
  NOW = 'Now',
  SCHEDULE = 'Schedule',
}
